let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2iXBu")).then(() => parcelRequire('eWVNZ'));